export const LANGS = ['tr', 'en'];

const pathLang = window.location.pathname.split('/')[1];

export const userPreferredLocale = LANGS.includes(pathLang) ? pathLang : 'tr';

// export const userPreferredLocale = LANGS.includes(
//   window.location.pathname.split('/')[1],
// )
//   ? window.location.pathname.split('/')[1]
//   : navigator.language.startsWith('tr')
//     ? 'tr'
//     : 'en';

export const userPreferredTheme = window.matchMedia(
  '(prefers-color-scheme: dark)',
).matches
  ? 'dark'
  : 'light';

export const COMPANY_NAME =
  'e-Metal Elektrik Metal Sanayi ve Dış Tic. Ltd. Şti.';
export const GOOGLE_MAP = 'https://maps.app.goo.gl/gVrtS8drscP3nAS7A';
export const MOBILE_PHONE = '05559725285';
export const BUSINESS_PHONE = '02163073861';
export const ADDRESS =
  'Veli Baba Mah. Mimar Sinan Caddesi Veli Baba Sanayi Sitesi No : 31 İç Kapı No: A1 Pendik/İSTANBUL';
export const EMAIL = 'info@e-metal.com.tr';
